import { ArrowDown } from '@ui/components/icons';
import { useIsPairClose } from '@ui/features/RWA/hooks/useIsPairClose';
import { SleepIndicator } from '@ui/features/RWA/SleepIndicator';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { Button } from '@ui/lib/park/ui/button';
import { Icon } from '@ui/lib/park/ui/icon';
import { Text } from '@ui/lib/park/ui/text';
import { Price24hDayStat } from '@ui/views/Trade/StatSection/components/Price24h';
import { TokenPrice } from '@ui/views/Trade/StatSection/components/TokenPrice';
import { styled } from 'styled-system/jsx';

import { MassTokenSelectModal } from '../MassTokenSelectModal';

export const TradeableTokenMenuSelect = () => {
  const selectedTradingPair = useTradingPair((s) => s.useTradingPair());
  const isPairSleeping = useIsPairClose(selectedTradingPair);

  return (
    <MassTokenSelectModal>
      <Button textStyle="headings.large" variant="text">
        <styled.img
          src={selectedTradingPair.image}
          boxSize="20px"
          borderRadius="6px"
        />
        {selectedTradingPair.baseName}
        {isPairSleeping && <SleepIndicator />}
        <TokenPrice />
        <Price24hDayStat />
        <Icon boxSize="16px">
          <ArrowDown />
        </Icon>
      </Button>
    </MassTokenSelectModal>
  );
};
